
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getAdminAuditList, tableExport } from '@/api/task/admin'
import { dateToSeconds, pickerOptions, getSystemDate } from '@/utils/dateTime'
import pagination from '@/components/Pagination/index.vue'
import { delObjEmptyKey } from '@/utils'
import { auditStatusList, timeTypeList } from '@/utils/constant'
import review from './components/review.vue'
import { AppModule } from '@/store/modules/app'
import { clipboardSuccess } from '@/utils/clipboard'
import batchReview from './components/batchReview.vue'

@Component({
  name: 'applicationIndex',
  components: {
    pagination,
    review,
    batchReview
  }
})
export default class extends Vue {
  private queryForm: any = {
    start_time: null,
    end_time: null,
    status: null,
    // begin_handle_time: null,
    // end_handle_time: null,
    // handle_time_unit: timeTypeList[0],
    created_by_name: null,
    approved_by_name: null,
    id: null
  }
  private statusList: any[] = auditStatusList
  private timeTypeList = timeTypeList
  private date: any[] = getSystemDate()
  private handleDate: any[] = []
  private pickerOptions = pickerOptions
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private qrUrl: string = ''
  private currentOrder: any | null = null
  private dialogVisible: boolean = false
  private dialogVisible2: boolean = false
  private resetApiKeyVisible: boolean = false

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  private isShowIp: boolean = false

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      this.orderList = []
      delObjEmptyKey(data)
      await getAdminAuditList(data).then((res: any) => {
        this.total = res.count
        this.orderList = res.results
        let a = this.orderList.findIndex(obj => obj.ip)
        if (a === 0) {
          this.isShowIp = true
        }
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private selectList: any[] = []
  private handleSelectionChange(list) {
    this.selectList = list
  }

  private batchReview: boolean = false
  private ordernumbers: any[] = []
  private openBatch() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (
        this.selectList[i].status === '0' ||
        this.selectList[i].status === 0
      ) {
        this.ordernumbers.push(this.selectList[i].id)
      }
    }
    this.batchReview = true
  }
  private closeBatch() {
    this.batchReview = false
    this.hadleGetFilesListApi()
  }

  private openDialog(param: any) {
    this.currentOrder = param
    this.currentOrder.status_display = this.statusList[param.status * 1].text
    this.dialogVisible = true
  }

  private closeDialog(qrUrl: string | null) {
    this.dialogVisible = false
    this.currentOrder = null
    this.hadleGetFilesListApi()
    if (qrUrl) {
      this.qrUrl = qrUrl
      this.dialogVisible2 = true
    }
  }

  private closeReset(apiKey: string | null) {
    this.dialogVisible = false
    this.currentOrder = null
    this.hadleGetFilesListApi()
    if (apiKey) {
      this.qrUrl = apiKey
      this.resetApiKeyVisible = true
    }
  }
  private clipboardSuccess() {
    this.$message({
      message: 'Copy successfully',
      type: 'success',
      duration: 2000
    })
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      start_time: null,
      end_time: null,
      status: null,
      // begin_handle_time: null,
      // end_handle_time: null,
      // handle_time_unit: timeTypeList[0],
      product_name: null,
      product_account_name: null,
      created_by_name: null,
      approved_by_name: null,
      id: null
    }
    this.date = getSystemDate()
    this.currentPage = 1
    this.pickerChange()
    this.handleDate = []
    this.hadleGetFilesListApi()
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await tableExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private async init() {
    this.hadleGetFilesListApi()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.init()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.applicationTask`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
